import { getOpenSizingSKUsFromProduct } from "@faire/retailer-visitor-shared/lib/SKUsUtils";
import { trackEditCartItemEvent } from "@faire/retailer-visitor-shared/services/Events";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { trackSamplesBuyFromSamplesCarouselClick } from "@faire/web-api--source/events/samples/click/buyFromSamplesCarousel";
import { trackSamplesRetailerSampleRequestButtonWebView } from "@faire/web-api--source/events/samples/view/retailerSampleRequestButtonWeb";
import { trackTaxonomyProductLanguageOptionAtcSuccess } from "@faire/web-api--source/events/taxonomy/success/productLanguageOptionAtc";
import { trackUpmarketProductDetailsPageSkuView } from "@faire/web-api--source/events/upmarket/view/productDetailsPageSku";
import { ProductVariationType } from "@faire/web-api--source/indigofair/data/ProductVariationType";
import brandPath from "@faire/web-api--source/routes/www/brand/brandToken";
import { route as brandRoute } from "@faire/web-api--source/routes/www/brand/brandToken";
import { route as cartRoute } from "@faire/web-api--source/routes/www/cart";
import qs from "query-string";
// Source of where this is called from. If we start using this in more than one
// place, we can turn this into an enum:
export var ADD_TO_CART_SOURCE_BRAND_PAGE = "Brand-BuyFromSamples";
export var trackViewRequestSamplesCTAEvent = function(brandToken, productToken) {
    trackSamplesRetailerSampleRequestButtonWebView("PDP_BUY_BOX", brandToken !== null && brandToken !== void 0 ? brandToken : "", productToken !== null && productToken !== void 0 ? productToken : "");
};
export var trackSKUViewEvent = function(selectedOption, isOpenSizingVariant, currentStyleHasOnlyPrePacks, product) {
    if (isOpenSizingVariant) {
        var skus = getOpenSizingSKUsFromProduct(product, selectedOption);
        trackSKUView("open-sizing", skus);
    } else {
        var sku = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.brand_code;
        var skuType = currentStyleHasOnlyPrePacks ? "prepack" : "single";
        trackSKUView(skuType, sku);
    }
};
export var trackEditQuantityEvent = function(selectedQuantity, productOptionInCart, brandToken, pathname, onChangeQuantity) {
    var productQuantityInCart = productOptionInCart === null || productOptionInCart === void 0 ? void 0 : productOptionInCart.quantity;
    if (!productQuantityInCart) {
        return;
    }
    if (onChangeQuantity) {
        onChangeQuantity(productOptionInCart === null || productOptionInCart === void 0 ? void 0 : productOptionInCart.product_option_token, productQuantityInCart, selectedQuantity);
        return;
    }
    var containerName;
    if (pathname === cartRoute) {
        containerName = "primary_cart_quick_add_modal";
    } else if (brandToken && pathname === brandPath(brandToken)) {
        containerName = "brand_page_side_cart_quick_add_modal";
    }
    if (containerName) {
        var _productOptionInCart_product_option_token;
        trackEditCartItemEvent(productQuantityInCart, selectedQuantity, containerName, (_productOptionInCart_product_option_token = productOptionInCart === null || productOptionInCart === void 0 ? void 0 : productOptionInCart.product_option_token) !== null && _productOptionInCart_product_option_token !== void 0 ? _productOptionInCart_product_option_token : "");
    }
};
export var trackAddToCartEvent = function(search, selectedOption, productOptionInCart, productToken, pathname, typedContext, onAddToCart) {
    var source = qs.parse(search).source;
    if (source === ADD_TO_CART_SOURCE_BRAND_PAGE) {
        trackSamplesBuyFromSamplesCarouselClick("BRAND", productToken !== null && productToken !== void 0 ? productToken : "");
    }
    if (onAddToCart) {
        onAddToCart(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.token);
        return;
    }
    if (pathMatchesRoute(pathname, brandRoute)) {
        trackEvent("/container/brand_page/quick_add_with_options_chosen/".concat(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.token));
    }
    if (typedContext || pathname === cartRoute && !(productOptionInCart === null || productOptionInCart === void 0 ? void 0 : productOptionInCart.quantity)) {
        var _typedContext_containerName;
        var container = (_typedContext_containerName = typedContext === null || typedContext === void 0 ? void 0 : typedContext.containerName) !== null && _typedContext_containerName !== void 0 ? _typedContext_containerName : "brand_cart_product_recommendations_product_details";
        var cartAddType = !typedContext || typedContext.containerName === "product_page" ? "add_to_cart" : "quick_add_with_options_chosen";
        trackEvent("/container/".concat(container, "/").concat(cartAddType, "/").concat(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.token));
    }
};
export var trackTaxonomyProductLanguageOptions = function(selectedOption) {
    var _selectedOption_variations_find;
    var productLanguageSelectedOption = selectedOption === null || selectedOption === void 0 ? void 0 : (_selectedOption_variations_find = selectedOption.variations.find(function(variation) {
        return variation.type === ProductVariationType.LANGUAGE;
    })) === null || _selectedOption_variations_find === void 0 ? void 0 : _selectedOption_variations_find.value;
    if (productLanguageSelectedOption) {
        trackTaxonomyProductLanguageOptionAtcSuccess(productLanguageSelectedOption);
    }
};
var trackSKUView = function(skuType, sku) {
    if (sku) {
        trackUpmarketProductDetailsPageSkuView(skuType, sku);
    }
};
